import { render, staticRenderFns } from "./MovieList.vue?vue&type=template&id=145fb3d0&"
import script from "./MovieList.vue?vue&type=script&lang=js&"
export * from "./MovieList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports